<template>
  <fade-transition :duration="150">
    <div v-if="isPopupVisible" class="survey-popup">
      <div :style="wrapperStyle" class="survey-popup__iframe-wrapper">
        <iframe
          :src="surveyUrl"
          :style="dynamicStyle"
          class="survey-popup__iframe"
        />
      </div>
      <div class="survey-popup__close-wrapper">
        <div v-focusable @click.stop="closePopup" class="close-icon" />
      </div>
    </div>
  </fade-transition>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ASurveyPopup',
  data() {
    return {
      surveyNumberToShow: null,
      iframeHeight: 300,
      isPopupVisible: false
    }
  },
  computed: {
    ...mapGetters({
      mobileBottomPadding: 'mobileBottomPadding'
    }),
    surveyUrl() {
      return this.$helper.getLinkToFmBucketFile(
        `survey_q${this.surveyNumberToShow}.html`
      )
    },
    wrapperStyle() {
      return {
        paddingBottom: `${this.mobileBottomPadding}px`
      }
    },
    dynamicStyle() {
      return {
        height: `${this.iframeHeight}px`
      }
    }
  },
  methods: {
    registerSurveyPopupListener() {
      this.$bus.$on('show-popup-survey', ({ surveyCounter }) => {
        this.surveyNumberToShow = surveyCounter

        this.isPopupVisible = true
      })
    },
    registerIframeListener() {
      window.addEventListener('message', this.handleIframeMessage)
    },
    handleIframeMessage(event) {
      if (event.data && event.data.type === 'closeSurveyModal') {
        this.closePopup()
      }

      if (event.data && event.data.type === 'height') {
        this.iframeHeight = event.data.value + 20
      }
    },
    closePopup() {
      this.isPopupVisible = false
    }
  },
  mounted() {
    this.registerSurveyPopupListener()
    this.registerIframeListener()
  },
  beforeDestroy() {
    this.$bus.$off('show-popup-survey')
    window.removeEventListener('message', this.handleIframeMessage)
  }
}
</script>

<style lang="scss" scoped>
.survey-popup {
  background: $c--white;
  width: 306px;
  box-shadow: 0 3px 15px 0 rgba(140, 77, 223, 0.12),
    0 1.5px 4px rgba(140, 77, 223, 0.09);
  position: fixed;
  border-radius: 10px 10px 0 0;
  bottom: 0;
  right: 40px;
  margin: 0;
  z-index: $z-index-popup-survey;

  @include mobile {
    left: 50%;
    transform: translateX(-50%);
    right: auto;
  }

  .survey-popup__iframe-wrapper {
    padding: 2px 12px 6px;
  }

  .survey-popup__iframe {
    width: 100%;
  }

  .survey-popup__close-wrapper {
    position: absolute;
    width: 100%;
    height: 35px;
    top: 0;
    left: 0;
    z-index: 10;

    .close-icon {
      position: absolute;
      fill: $c--main;
      right: 10px;
      top: 10px;
    }
  }
}
</style>
